import { Controller } from '@hotwired/stimulus';

/**
 * NotebookTitleController
 *
 * Keeps the notebook header backlink and the browser tab title in sync with the
 * group name when it is edited inline, so neither goes stale without a full page
 * reload.
 *
 * Listens for the `notebook:group-name-changed` event dispatched by the inline
 * group-name field (see inline_editable/Context.jsx) and rewrites the header
 * text and document.title from the surrounding copy passed in as values.
 *
 * @example
 * <div data-controller="notebook-title"
 *      data-notebook-title-header-suffix-value=" Notebook"
 *      data-notebook-title-document-prefix-value="Notebook | "></div>
 */
const HEADER_SELECTOR = "[data-qa='notebook-header'] h3";

export default class extends Controller {
  static values = {
    headerSuffix: String,
    documentPrefix: String
  };

  connect() {
    this.handleNameChange = this.handleNameChange.bind(this);
    window.addEventListener('notebook:group-name-changed', this.handleNameChange);
  }

  disconnect() {
    window.removeEventListener('notebook:group-name-changed', this.handleNameChange);
  }

  handleNameChange(event) {
    const { name } = event.detail;
    const header = document.querySelector(HEADER_SELECTOR);

    if (header) {
      header.textContent = `${name}${this.headerSuffixValue}`;
    }
    document.title = `${this.documentPrefixValue}${name}`;
  }
}
